import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Eye, Moon, Brain } from 'lucide-react';
const moments = [{
  icon: <Eye size={24} className="text-sage-700" data-id="element-98" />,
  text: "Si te miras al espejo y no reconoces tu abdomen, a pesar de comer 'bien'..."
}, {
  icon: <Moon size={24} className="text-sage-700" data-id="element-99" />,
  text: 'Si te despiertas a las 3:00 AM con la mente a mil y el cuerpo agotado...'
}, {
  icon: <Brain size={24} className="text-sage-700" data-id="element-100" />,
  text: 'Si sientes que la neblina mental está robando tu claridad...'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.18
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function EmpathySection() {
  return <section className="py-20 md:py-32 bg-cream-dark relative overflow-hidden" data-id="element-101">
      {/* Decorative background blob */}
      <div className="absolute top-20 left-0 w-96 h-96 bg-sage-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 pointer-events-none" data-id="element-102"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-14" data-id="element-104">
          <span className="inline-block py-1 px-3 rounded-full bg-sage-100 text-sage-800 text-xs font-semibold tracking-widest uppercase mb-6" data-id="element-105">
            La Verdad Incómoda
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight" data-id="element-106">
            No es falta de disciplina.
            <br data-id="element-107" />
            <span className="text-sage-700 italic" data-id="element-108">Es tu mapa hormonal.</span>
          </h2>
        </motion.div>

        {/* "Si..." moments — editorial vertical list */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className="space-y-4 md:space-y-5 mb-12 md:mb-16 max-w-3xl mx-auto" data-id="element-109">
          {moments.map((m, i) => <motion.div key={i} variants={itemVariants} className="bg-cream rounded-2xl border border-sage-100 px-6 py-5 md:px-8 md:py-6 flex items-start gap-4 md:gap-5 shadow-sm" data-id="element-110">
              <div className="flex-shrink-0 w-11 h-11 bg-sage-100 rounded-full flex items-center justify-center" data-id="element-111">
                {m.icon}
              </div>
              <p className="text-lg md:text-xl font-serif italic text-charcoal leading-snug pt-1" data-id="element-112">
                {m.text}
              </p>
            </motion.div>)}
        </motion.div>

        {/* Strong closing statement */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.7,
        delay: 0.1
      }} className="max-w-3xl mx-auto text-center" data-id="element-113">
          <div className="bg-sage-800 text-cream rounded-3xl px-7 py-10 md:px-12 md:py-14 shadow-xl" data-id="element-114">
            <p className="text-xl md:text-2xl leading-relaxed font-serif" data-id="element-115">
              <span className="block mb-3 font-semibold tracking-wide" data-id="element-116">
                No es tu culpa.
              </span>
              <span className="block mb-3 font-semibold tracking-wide" data-id="element-117">
                No es envejecimiento <em data-id="element-118">"normal"</em>.
              </span>
              <span className="block text-sage-100/90" data-id="element-119">
                Es una{' '}
                <strong className="text-yellow-300 font-semibold not-italic" data-id="element-120">
                  crisis de Cortisol
                </strong>{' '}
                que tu cuerpo no sabe cómo gestionar sola.
              </span>
              <span className="block mt-6 text-2xl md:text-3xl font-bold italic text-cream" data-id="element-121">
                Hasta hoy.
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}